import { isToday } from './utils'

export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

export const title = (value, replacer = ' ') => {
  if (!value) return ''
  const str = value.toString()

  const arr = str.split(replacer)
  const capitalizedArray = []
  arr.forEach(word => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })
  return capitalizedArray.join(' ')
}

export const avatarText = value => {
  if (!value) return ''
  const nameArray = value.split(' ')
  return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
}

/**
 * Format and return date in Humanize format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('pt-br', formatting).format(new Date(value))
}

/**
 * Return short human friendly month representation of date
 * Can also convert date to only time if date is of today (Better UX)
 * @param {String} value date to format
 * @param {Boolean} toTimeForCurrentDay Shall convert to time if day is today/current
 */
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// format data time to br
export const formatDateTimeBr = value => {
  if (!value) return value
  return new Intl.DateTimeFormat('pt-br', {
    month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric',
  }).format(new Date(value))
}

export const formatDateBr = value => {
  if (!value) return value
  return new Intl.DateTimeFormat('pt-br').format(new Date(value))
}

// Strip all the tags from markup and return plain text
export const filterTags = value => value.replace(/<\/?[^>]+(>|$)/g, '')

// eslint-disable-next-line no-shadow
export const currency = (value, currency = 'BRL') => {
  if (!value) return ''
  return new Intl.NumberFormat('pt-br', { style: 'currency', currency }).format(value) || ''
}

export const currencyInt = (value, currency = 'BRL') => {
  if (!value) return ''
  return new Intl.NumberFormat('pt-br', { style: 'currency', currency }).format(value / 100)
}

export const currencyIntCents = (value, currency = 'BRL') => {
  let val = `${value}`.replaceAll(/[^0-9]/g, '')
  val = (val / 10) / 100
  if (val === 0) {
    val = 'R$ 0,00'
  }
  return new Intl.NumberFormat('pt-br', { style: 'currency', currency }).format(val / 100)
}

export const formatPhone = value => {
  if (!value) return ''
  const valueString = value.replace(/\D/g, '')
  if (valueString.length === 11) {
    return valueString.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  }
  return valueString.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
}

export const formatDocumento = value => {
  if (!value) return '';

  const valueString = value.replace(/\D/g, '');

  if (valueString.length === 11) {
    // Formatar CPF
    return valueString.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (valueString.length === 14) {
    // Formatar CNPJ
    return valueString.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    // Caso não seja nem CPF nem CNPJ, retorna o valor original
    return valueString;
  }
};
